
import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface PurchaseExecuteInventoryCostParams {
    id: number;
}

export class PurchaseExecuteInventoryCostCommand extends Command<PurchaseExecuteInventoryCostParams, void> { }

@CommandHandlerFor(PurchaseExecuteInventoryCostCommand)
@Injectable({ providedIn: 'root'})
export class PurchaseExecuteInventoryCostCommandHandler {
    #Url = TaggedUrl.join('purchase/:id/executeInventoryCost', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(command: PurchaseExecuteInventoryCostCommand): Promise<any> {
        const url = fillPlaceholders(this.#Url, { id: command.params?.id });
        await this.#http.post(url);
    }
}
